/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoEdgeModel, RouteDtoEdgeModelType } from "./RouteDtoEdgeModel"
import { RouteDtoEdgeModelSelector } from "./RouteDtoEdgeModel.base"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  nodes: IObservableArray<RouteDtoModelType>;
}

/**
 * RoutePaginatedDtoBase
 * auto generated base class for the model RoutePaginatedDtoModel.
 */
export const RoutePaginatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RoutePaginatedDto')
  .props({
    __typename: types.optional(types.literal("RoutePaginatedDto"), "RoutePaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => RouteDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => RouteDtoModel)))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
    totalUnseenCount: types.union(types.undefined, types.null, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RoutePaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  get totalUnseenCount() { return this.__attr(`totalUnseenCount`) }
  edges(builder: string | RouteDtoEdgeModelSelector | ((selector: RouteDtoEdgeModelSelector) => RouteDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, RouteDtoEdgeModelSelector, builder) }
  nodes(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`nodes`, RouteDtoModelSelector, builder) }
}
export function selectFromRoutePaginatedDto() {
  return new RoutePaginatedDtoModelSelector()
}

export const routePaginatedDtoModelPrimitives = selectFromRoutePaginatedDto().totalCount.hasNextPage.totalUnseenCount
